interface Props {
  points: number;
  target: number;
  /** px size. Default 280. */
  size?: number;
}

// Slate points-target ring for the home cockpit. SVG so it scales crisply
// at any density. The ring's stroke offset reflects progress.
//
// Visual intent: confident, in-the-room, engineering instrument. Dominates
// the landing screen. Uses accent-progress (slate-blue) — keeps amber free
// for active-state / "you're on" affordances elsewhere.
export function PointsRing({ points, target, size = 280 }: Props) {
  const safeTarget = Math.max(target, 1);
  const pct = Math.min(points / safeTarget, 1);
  const stroke = 14;
  const r = (size - stroke) / 2;
  const c = size / 2;
  const circumference = 2 * Math.PI * r;
  const offset = circumference * (1 - pct);

  return (
    <div
      className="relative flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={c}
          cy={c}
          r={r}
          fill="none"
          stroke="currentColor"
          strokeWidth={stroke}
          className="text-graphite-100"
        />
        <circle
          cx={c}
          cy={c}
          r={r}
          fill="none"
          stroke="currentColor"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          className="text-accent-progress transition-[stroke-dashoffset] duration-700 ease-out"
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="font-sans text-[5rem] font-semibold leading-none tracking-tight text-graphite-900 tabular-nums">
          {points}
        </span>
        <span className="mt-2 font-mono text-xs uppercase tracking-[0.18em] text-graphite-500">
          of {safeTarget} points today
        </span>
      </div>
    </div>
  );
}
